export const defaultSelectedDateUp = () => {
    return new Date()
};
export const defaultSelectedDateFrom = () => {
    var fecha = new Date();
    // Obtener el mes y año actuales
    const mesActual = fecha.getMonth();
    const anioActual = fecha.getFullYear();

    // Calcular el nuevo mes y año
    let nuevoMes = mesActual - 1;
    let nuevoAnio = anioActual;

    // Manejar el cambio de año si el nuevo mes es menor a 0
    while (nuevoMes < 0) {
        nuevoMes += 12;
        nuevoAnio--;
    }

    // Establecer la nueva fecha con los meses restados
    fecha.setMonth(nuevoMes);
    fecha.setFullYear(nuevoAnio);

    return fecha;

};

export default {
  loading: {
      module:false
  },
  params: {
      year_month_from: defaultSelectedDateFrom(),
      year_month_up: defaultSelectedDateUp(),
      branch_office_id:null,
      vouchertype_code: null,
      contact_id: null,
  },
  params_contacts: {
   only_active:true,
   filter: "",
   paginate: false
  },
  contacts:[]

};



// WEBPACK FOOTER //
// ./src/modules/delete-documents/state.js